export default __webpack_public_path__ + "static/media/where-is-the-ball.19615a73.png";